<template>
  <span v-if="hasProductPhotos">
    <DocumentAnalysisBadge
      :verdict="analysisVerdict"
      :is-analyzed="Boolean(productPhotosAnalyzedAt)"
      :has-error="analysisHasError"
      :tooltip="analysisBadgeLabel"
      :clickable="canOpenAnalysisModal"
      @click="analysisModalOpen = true"
    />
    <ProductPhotosAnalysisModal
      :open="analysisModalOpen"
      :analysis="productPhotosAnalysis"
      :analyzed-at="productPhotosAnalyzedAt"
      :analysable-id="declaration.id"
      analysable-type="Claims::Declaration"
      :claim-active="claimActive"
      @close="analysisModalOpen = false"
      @retry-success="$emit('retry-success')"
    />
  </span>
</template>

<script>
import { useI18n } from "vue-i18n";
import DocumentAnalysisBadge from "@/components/claim/details/DocumentAnalysisBadge.vue";
import ProductPhotosAnalysisModal from "@/components/claim/details/ProductPhotosAnalysisModal.vue";
import { verdictLabel } from "@/components/claim/details/productPhotosAnalysisFormatter";

export default {
  components: {
    DocumentAnalysisBadge,
    ProductPhotosAnalysisModal,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  emits: ["retry-success"],
  props: {
    declaration: {
      type: Object,
      default: null,
    },
    claimActive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      analysisModalOpen: false,
    };
  },

  computed: {
    hasProductPhotos() {
      return (this.declaration?.productPhotos?.length || 0) > 0;
    },
    productPhotosAnalysis() {
      return this.declaration?.productPhotosAnalysis || null;
    },
    productPhotosAnalyzedAt() {
      return this.declaration?.productPhotosAnalyzedAt || null;
    },
    analysisVerdict() {
      return this.declaration?.productPhotosAnalysisVerdict || null;
    },
    analysisHasError() {
      return Boolean(this.productPhotosAnalysis?.error);
    },
    canOpenAnalysisModal() {
      return Boolean(this.productPhotosAnalyzedAt) || this.analysisHasError;
    },
    analysisBadgeLabel() {
      if (this.analysisHasError) return this.t("unavailable");
      if (!this.productPhotosAnalyzedAt) return this.t("not_analyzed");
      return verdictLabel(this.analysisVerdict);
    },
  },
};
</script>

<i18n src="./ProductPhotosAnalysisBadge.i18n.json"></i18n>
